export default __webpack_public_path__ + "static/media/nf.c9745bcb.svg";